import { Component, DoCheck, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FiltersService } from 'src/app/core/services/filters.service';

@Component({
    selector: 'app-account-specific-filter',
    templateUrl: './account-specific-filter.component.html',
    styleUrls: ['./account-specific-filter.component.scss'],
    standalone: false
})
export class AccountSpecificFilterComponent implements OnInit, DoCheck {

  value: string = '';
  @Input() divDataView = "";
  @Input() resetFlag: boolean = false;
  @Input() accountFieldTitle: string = '';
  @Output() sendSelect = new EventEmitter<string>();

  constructor(
    private filtersService: FiltersService,
  ) { }

  ngOnInit(): void {
    this.accountFieldTitle = this.divDataView === 'Pest' ? 'Service Account ID' : 'Account Number(s)';
  }

  ngDoCheck(): void {
    if (this.resetFlag){
      this.clear();
    }
  }

  onInput(){
    // call remember choices, use title as name for localstorage but remove the spaces
    this.filtersService.rememberPriorChoices('ebr' + this.divDataView + this.accountFieldTitle.split(' ').join(''), this.value);
    this.sendSelect.emit(this.value);
  }

  recalledItems(items: string) {
    this.value = items;
    this.sendSelect.emit(this.value);
  }

  clear(){
    this.value = '';
  }
}
